<template>
    <!-- <PopularParkingLotsSection
        v-if="firstTwoProducts.length"
        v-editable="blok"
        :products="firstTwoProducts"
        :summary-info="summaryInfo"
        :blok="blok"
    /> -->
    <AprProductsCarousel
        v-if="firstTwoProducts.length"
        :blok="blok"
        :products="firstTwoProducts"
        :section-config="sectionConfig"
    />
</template>

<script setup lang="ts">
import AprProductsCarousel from '~/components/sections/AprProductsCarousel.vue';
import type { IProductsSectionConfig } from '~/../types/ProductsCarousel';
// import PopularParkingLotsSection from '../components/sections/parking/PopularParkingLotsSection.vue';
import type { IPopularPortParkingConfig } from '@nuxt-monorepo/ui/types/components/Parking';

import type { IAirportProducts, IParkingSummary, IParkingProduct } from '@nuxt-monorepo/ui/types';
const { products } = defineProps<{ blok: IPopularPortParkingConfig; products: IAirportProducts }>();
const firstTwoProducts = computed(() => {
    return Array.isArray(products.parking)
        ? products.parking
              .filter((product: IParkingProduct) => {
                  return product.service === true;
              })
              .slice(0, 2)
        : [];
});

const summaryInfo: IParkingSummary = inject('parkingSummary');

const sectionConfig: IProductsSectionConfig = {
    title: 'title',
    subtitle: {
        subtitleName: 'text',
        subtitleType: 'RichText',
    },
    cardType: 'ParkingLotProductCard',
};
</script>
